/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { setLanguageSettings } from '../../shared/utils/uiDirectionUtils';

export default function useLanguageMenu() {
  const { i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const changeLanguage = (lng, direction = 'ltr') => {
    document.dir = direction;
    setLanguageSettings({ language: lng, direction });
    window.location.reload();
    i18n.changeLanguage(lng);
  };

  return {
    anchorEl,
    handleClose,
    handleClick,
    changeLanguage,
  };
}
